import {FILTER_ALL, FILTER_CUSTOM, FILTER_NONE} from './filters';

export default [
  {key: FILTER_ALL, label: 'Alle Schicht.'},
  {key: FILTER_CUSTOM, label: 'gefiltert (Schicht.)'},
  {key: FILTER_NONE, label: 'Keine Schicht.'},
];
